import * as configService from "./configService";

/**
 * Function which is used to make API call to fetch geoblocks data for provided poi id
 * @param {*} poiId Poi id for which geoblocks data needs to be fetched
 */
export function fetchPoiGeoBlocksAffinityData(poiId, authToken) {
  const queryParams = {
    poi_ids: poiId,
  };
  const finalBaseUrl = new URL(`geoblocks/v1/pois`, configService.getConfig().GEO_SERVICE_URL);
  Object.keys(queryParams).forEach((key) => finalBaseUrl.searchParams.append(key, queryParams[key]));
  return fetch(finalBaseUrl, {
    headers: {
      "x-gt-session": authToken,
    },
  });
}

/**
 * Function which is used to make API call to fetch name and address data for provided poi ids
 * @param {*} poiId List of poi ids for which name and address needs to be fetched
 */
export function fetchPoiNameAndAddress(poiIds, authToken) {
  const queryParams = {
    poi_ids: poiIds.toString(),
  };
  const finalBaseUrl = new URL(`name/v1/pois`, configService.getConfig().GEO_SERVICE_URL);
  Object.keys(queryParams).forEach((key) => finalBaseUrl.searchParams.append(key, queryParams[key]));
  return fetch(finalBaseUrl, {
    headers: {
      "x-gt-session": authToken,
    },
  });
}
